
import { Component, Prop, Vue } from "vue-property-decorator";
import httpClient from "../../store/httpClient";
import rules from "@/store/rules";

@Component({})
export default class CreateMahnungDialog extends Vue {
	@Prop()
	private show!: boolean;
	@Prop()
	private invoiceId!: number;
	@Prop()
	private dueDate!: Date;
	private cost: number = 0;
	private isLoading: boolean = false;
	private positiveNumberRule = rules.requiredNonNegativeNumberRule;

	private get isDue() {
		let dateNow = new Date();
		let compareDate = new Date(this.dueDate);
		dateNow.setHours(0, 0, 0, 0);
		compareDate.setHours(0, 0, 0, 0);
		return compareDate <= dateNow;
	}

	private async createMahnung() {
		if (this.isLoading) {
			return;
		}
		try {
			this.isLoading = true;
			console.log("Creating new Mahnung ...");
			await httpClient().post(
				`Invoice/CreateMahnung?invoiceId=${this.invoiceId}&cost=${this.cost}`
			);
			this.cost = 0;
			this.$store.commit("setDueInvoiceAsGemahnt", this.invoiceId);
			this.$emit("saved");
		} catch (e) {
			console.log("Creating new Mahnung failed.", e);
		} finally {
			this.isLoading = false;
			this.close();
		}
	}

	private get isValidCost() {
		return !!this.cost.toString() && !isNaN(this.cost) && this.cost >= 0;
	}

	private close() {
		this.$emit("close");
	}
}
